import { twMerge } from 'tailwind-merge';

const COLOR_STYLES_BY_VARIANT = {
  primary:
    '!bg-brand-900 hover:!bg-brand-1000 focus:!bg-brand-1000 disabled:!bg-base-400 text-white',
  secondary:
    '!bg-brand-300 hover:!bg-brand-400 focus:!bg-brand-400 disabled:!bg-base-400 text-white',
  error:
    '!bg-destructive-500 hover:!bg-destructive-600 focus:!bg-destructive-600 disabled:!bg-base-400 text-white',
  blue: '!bg-brand-100 hover:!bg-brand-200 focus:!bg-brand-200 disabled:!bg-base-200/50 disabled:text-base-400 text-brand-900',
  text: '!bg-white hover:!bg-base-200/50 focus:!bg-base-200/50 disabled:!bg-white disabled:text-base-400 text-base-800',
};

export const Button = ({
  title,
  variant = 'primary',
  iconStart,
  iconEnd,
  className,
  ...props
}) => {
  return (
    <button
      className={twMerge(
        'h-12 py-3 px-[22px] font-medium text-[18px]/[24px] rounded-full border-none outline-none flex justify-center items-center gap-2',
        COLOR_STYLES_BY_VARIANT[variant],
        className,
      )}
      {...props}
    >
      {!!iconStart && iconStart} {title} {!!iconEnd && iconEnd}
    </button>
  );
};
